import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';

interface Props extends ComponentViewProps<DataSet<TourItineraryItem>> {
	mode: ControlMode;
	onItemDoubleClicked: (item?: TourItineraryItem) => any;
}

@observer
export class ProductItineraryView extends React.Component<Props, any> {
	private columns: Column[] = [
		{
			key: 'displayName',
			title: 'Itinerary',
			dataIndex: 'displayName',
			render: (text, record, index) => {
				return record.dynamicProperties.displayName.en;
			}
		},
		{
			key: 'service',
			title: 'Service',
			dataIndex: 'productServiceTypeDisplayName'
		},
	];

	public render() {
		return (
			<DataTableView
				mode={this.props.mode}
				createNewItem={this.props.onItemDoubleClicked}
				setBusy={this.props.setBusy}
				columns={this.columns}
				model={this.props.model}
				hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
				itemDoubleClick={this.props.onItemDoubleClicked}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-itinerary.view.tsx